import { render, staticRenderFns } from "./SideMenuComponent.vue?vue&type=template&id=7a1d75fb&scoped=true&"
import script from "./SideMenuComponent.vue?vue&type=script&lang=js&"
export * from "./SideMenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1d75fb",
  null
  
)

export default component.exports